import { RouteLocation as Route } from 'vue-router';
import { getSignInOpts, getSignOutOpts } from 'src/services/cognito';

const LOGIN_CODE_PARAM = 'code';
const LOGIN_ERROR_PARAM = 'error_description';

export default class Query {
  static create(route: Route) {
    return new Query(route);
  }

  private route: Route;

  constructor(router: Route) {
    this.route = router;
  }

  getSearchParam(param: string) {
    if (param in this.route.query) {
      return this.route.query[param] as string;
    }
    return '';
  }

  getLoginCode() {
    const code = this.getSearchParam(LOGIN_CODE_PARAM);
    return code ? code : null;
  }
  getErrorDesc() {
    const error = this.getSearchParam(LOGIN_ERROR_PARAM);
    return error ? error : '';
  }
}

// export function navigateUserToHome(user: ApiClient.Types.User) {
//   const $router = useRouter();
//   switch (user.group) {
//     case 'administrator':
//       void $router.push({ name: 'admin' });
//       break;
//     case 'manual':
//       void $router.push({ name: 'jobs' });
//       break;
//     default:
//       void $router.push({ name: 'dashboard' });
//   }
// }

export function navigateToUrl(url: string) {
  window.location.href = url;
}

export function buildUrlSimple({
  BASE_URL: baseUrl,
  PARAMS: params,
}: {
  BASE_URL: string;
  PARAMS: Record<string, string>;
}) {
  const opts = Object.keys(params).map((key) => `${key}=${params[key]}`);

  return `${baseUrl}?${opts.join('&')}`;
}

export const getSignOutUrl = (hostUrl: string) => {
  return buildUrlSimple(
    getSignOutOpts({
      logout_uri: `https://${hostUrl}/auth`,
    })
  );
};

export const getSignInUrl = (hostUrl: string) => {
  return buildUrlSimple(
    getSignInOpts({
      redirect_uri: `https://${hostUrl}/auth`,
    })
  );
};

const REDIRECT_PATH_ITEM = 'redirectPath';

export const getRedirectPath = () => {
  return sessionStorage.getItem(REDIRECT_PATH_ITEM);
};

export const storeRedirectPath = () => {
  sessionStorage.setItem(REDIRECT_PATH_ITEM, document.location.pathname);
};

export const forgetRedirectPath = () => {
  sessionStorage.removeItem(REDIRECT_PATH_ITEM);
};
